import { z } from "zod";
import { reportFormatSchema, reportTypeSchema } from "./common";

export const REDACT_FIELD_OPTIONS = ["emails", "ipv4", "ipv6", "uuids"] as const;
export type RedactField = (typeof REDACT_FIELD_OPTIONS)[number];

/**
 * `POST /v1/reports` body. Mirrors `CreateReport` in routes_ops.rs, whose `params`
 * is an untyped `serde_json::Value` — there is no server-defined params schema, so
 * `days` / `redact_fields` here are a client-side convention packed into `params`,
 * not a server contract. The dialog sends `{ report_type, format, params }`.
 */
export const createReportFormSchema = z.object({
  report_type: reportTypeSchema,
  format: reportFormatSchema,
  days: z.coerce.number().int().min(1).max(3650).default(30),
  redact_fields: z.array(z.enum(REDACT_FIELD_OPTIONS)).default([]),
});
export type CreateReportFormInput = z.infer<typeof createReportFormSchema>;

export const createReportRequestSchema = z.object({
  report_type: reportTypeSchema,
  format: reportFormatSchema,
  params: z.record(z.unknown()).default({}),
});
export type CreateReportRequestInput = z.infer<typeof createReportRequestSchema>;

export function toCreateReportRequest(form: CreateReportFormInput): CreateReportRequestInput {
  return {
    report_type: form.report_type,
    format: form.format,
    params: { days: form.days, redact_fields: form.redact_fields },
  };
}
